import { map } from 'rxjs';

import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { AuthFacade } from '@/app/core/auth';

export const authGuard: CanMatchFn = () => {
  const authStore = inject(AuthFacade);

  return authStore.ensureAuth$().pipe(map((status) => (status === 'authed' ? true : authStore.redirectForGuest())));
};
